<script>
import { mapActions } from 'vuex';
import { cloneDeep, result } from 'lodash';
import RbxRemoteCombobox from '@/shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '@/shared/reybex/RbxRemoteComboboxMultiple';
import validatorMixin from '@/mixins/validator';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'NewUserDialog',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
  },
  mixins: [snackbarMixin, validatorMixin],
  data() {
    return {
      visible: false,
      isLoading: false,
      rules: {
        username: { required: true },
        password: { required: true },
        email: { required: true },
      },
      baseFormData: {
        username: '',
        password: '',
        email: '',
        firstname: '',
        surname: '',
        city: '',
        zipcode: '',
        street: '',
        fax: '',
        mobile: '',
        phone: '',
      },
      formData: {},
      roleOptions: [
        { id: 0, text: 'Normaler Benutzer' },
        { id: 1, text: 'Verfahren-Verantwortlicher' },
        { id: 2, text: 'Admin' },
      ],
      roleStatus: 0,
    };
  },
  created() {
    this.formData = cloneDeep(this.baseFormData);
  },
  mounted() {
    this.visible = true;
  },
  beforeDestroy() {
    /* istanbul ignore next */
    this.visible = false;
  },
  methods: {
    ...mapActions('userDetails', ['saveUser']),
    ...mapActions('userList', { fetchData: 'fetchUserList' }),
    submit(type) {
      if (!this.validateForm()) return false;

      this.isLoading = true;
      const self = this;

      this.formData.isProcedureDirectoryResponsible = this.roleStatus === 1;
      this.formData.isAdmin = this.roleStatus === 2;

      return this.saveUser(this.formData)
        .then(({ data }) => {
          self.showSuccessMessage('Benutzer erfolgreich erstellt!');

          if (type === 'new') {
            self.formData = cloneDeep(this.baseFormData);
          } else {
            self.close();

            if (type === 'detail') {
              self.$router.push(`/user/${data.id}`);
            }
          }
          // self.fetchData();
          self.$emit('submit');
        })
        .catch(({ response }) => {
          const message = result(response, 'data.data.error', 'Fehler beim Erstellen des Benutzers. Bitte versuche es erneut!');
          self.showErrorMessage(message);
        })
        .finally(() => {
          self.isLoading = false;
          console.log('FINALLY!');
        });
    },
    close() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="1000px">

    <v-card>
      <v-card-title class="title pa-3">
        Neuer Benutzer
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.username"
                :error-messages="validationErrorMessages.username"
                label="Benutzername"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.password"
                :error-messages="validationErrorMessages.password"
                label="Passwort"
                height="22"
                class="caption"
                type="password"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.email"
                :error-messages="validationErrorMessages.email"
                label="E-Mail-Adresse"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-select
                height="22"
                :items="roleOptions"
                v-model="roleStatus"
                item-value="id"
                item-text="text"
                label="Rolle"
              />
            </v-flex>

            <v-flex xs12 md12 py-0/>

            <v-flex xs12 md4 py-0>
              <rbx-remote-combobox
                v-model="formData.salutation"
                label="Anrede"
                domain="salutation"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.firstname"
                label="Vorname"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.surname"
                label="Nachname"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.phone"
                label="Telefon"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.mobile"
                label="Handy"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.fax"
                label="Fax"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.street"
                label="Straße"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.zipcode"
                label="PLZ"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.city"
                label="Stadt"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <rbx-remote-combobox
                v-model="formData.department"
                label="Abteilung"
                domain="department"
              />
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>

        <v-btn @click.native="submit"
               color="blue"
               :loading="isLoading"
               flat>
          Speichern
        </v-btn>

        <v-menu bottom left>
          <v-btn slot="activator" icon>
            <v-icon>expand_more</v-icon>
          </v-btn>

          <v-list>

            <v-list-tile>
              <v-list-tile-title @click="submit('new')">
                Speichern &amp; Neu
              </v-list-tile-title>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-title @click="submit('detail')">
                Speichern &amp; Detail
              </v-list-tile-title>
            </v-list-tile>

          </v-list>
        </v-menu>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
